import React from 'react';
import BaseComponent from './BaseComponent';
import {connect} from 'react-redux';
import classNames from 'classnames';
import {Link} from 'react-router';
import VenueList from './VenueList';
import BandList from './BandList';
import AccompanistList from './AccompanistList';
import Events from './Events';
import Entries from './Entries';
import {List, ListItem, ListBody, ListTitle} from './UIList';
import FacebookLogin from './FacebookLogin';
import FavouritesList from './FavouritesList';

const Panel = ({backPath, backLabel, header, children}) => {
    let backLink;

    if (backLabel && backPath) {
        backLink = <Link to={backPath}>‹ {backLabel}</Link>;
    }

    return <div className="viewer-panel">
        <div className="viewer-panel-header">
            {backLink}
            {header}
            <FacebookLogin />
        </div>
        <div className="viewer-panel-body">{children}</div>
    </div>;
};

const PlaceholderPanel = () => <Panel />;

export class PureViewer extends BaseComponent {
    render() {
        const {user, route: {path, mode, depth}} = this.props;

        const className = classNames('viewer', `viewer-${depth}`);

        return <div className={className}>
            <Panel header="Live Results">
                <p className="text-center">
                    Select how you'd like to view the schedule.
                </p>
                <List>
                    <ListItem to="/favourites" active={mode === 'favourites'}>
                        <ListBody><ListTitle>Favourites</ListTitle></ListBody>
                    </ListItem>
                    <ListItem to="/venue" active={mode === 'venue'}>
                        <ListBody><ListTitle>By Venue</ListTitle></ListBody>
                    </ListItem>
                    <ListItem to="/band" active={mode === 'band'}>
                        <ListBody><ListTitle>By Band</ListTitle></ListBody>
                    </ListItem>
                    <ListItem to="/accompanist" active={mode === 'accompanist'}>
                        <ListBody><ListTitle>By Accompanist</ListTitle></ListBody>
                    </ListItem>
                    {user.hasRole('admin') && <ListItem to="/admin/">
                        <ListBody><ListTitle>Admin</ListTitle></ListBody>
                    </ListItem>}
                </List>
            </Panel>
            {this.renderSecondPanel()}
            {this.renderThirdPanel()}
        </div>;
    }

    renderSecondPanel() {
        const {route, routeParams} = this.props;

        switch (route.mode) {
            case 'favourites':
                return <Panel header="Favourites" backPath="/" backLabel="Home">
                    <FavouritesList />
                </Panel>
            case 'venue':
                return <Panel header="Venues" backPath="/" backLabel="Home">
                    <VenueList selectedVenueID={routeParams.id} />
                </Panel>;
            case 'band':
                return <Panel header="Bands" backPath="/" backLabel="Home">
                    <BandList selectedBand={routeParams.id} />
                </Panel>;
            case 'accompanist':
                return <Panel header="Accompanists" backPath="/" backLabel="Home">
                    <AccompanistList selectedAccompanist={routeParams.id} />
                </Panel>;
        }

        return <PlaceholderPanel />;
    }

    renderThirdPanel() {
        const {route, routeParams, venues} = this.props;

        if (!routeParams.id) {
            return <PlaceholderPanel />;
        }

        switch (route.mode) {
            case 'venue':
                let venue = venues.get(routeParams.id);
                return <Panel header={venue.name} backPath="/venue" backLabel="Venues">
                    <Events venue={venue} />
                </Panel>;
            case 'band':
                return <Panel header={routeParams.id} backPath="/band" backLabel="Bands">
                    <Entries band={routeParams.id} showDates={true} />
                </Panel>;
            case 'accompanist':
                return <Panel header={routeParams.id} backPath="/accompanist" backLabel="Accompanists">
                    <Entries accompanist={routeParams.id} showDates={true} />
                </Panel>;
        }

        return <PlaceholderPanel />;
    }
}

function mapStateToProps({app}) {
    return {
        venues: app.get('venues'),
        user: app.get('user'),
    };
}

export default connect(mapStateToProps)(PureViewer);



/** WEBPACK FOOTER **
 ** ./src/components/Viewer.jsx
 **/